import styled, { css } from 'styled-components';

const getBackgroundImageUrl = ({
  isGalleryHeader,
  isCurrentItemPage,
  isWebView
}: {
  isGalleryHeader: boolean;
  isCurrentItemPage: boolean;
  isWebView: boolean;
}) => {
  switch (true) {
    case isGalleryHeader:
      return '/static/images/item/buttons-favorite-bordered.svg';
    case isCurrentItemPage:
      return '/static/images/item/buttons-favorite.svg';
    case isWebView:
      return '/static/images/webview/icon-favorite.svg';
    default:
      return '/static/images/icons-favorite.svg';
  }
};

const backgroundImageStyles = css<{
  $isActive: boolean;
  $isWebView: boolean;
  $isCurrentItemPage: boolean;
  $isGalleryHeader: boolean;
}>`
  background-position: 0 0;

  ${({ $isGalleryHeader, $isCurrentItemPage }) =>
    $isGalleryHeader || $isCurrentItemPage
      ? { top: '22px', right: '15px' }
      : { top: '10px', right: '10px' }};

  background-size: cover;
  background-repeat: no-repeat;
  transform: translateZ(0);
  background-image: url(${({
    $isGalleryHeader,
    $isCurrentItemPage,
    $isWebView
  }) =>
    getBackgroundImageUrl({
      isGalleryHeader: $isGalleryHeader,
      isCurrentItemPage: $isCurrentItemPage,
      isWebView: $isWebView
    })});

  ${({ $isActive }) =>
    $isActive &&
    css`
      background-position: 0 -20px;
    `};
`;

const currentItemIconsStyles = css`
  width: 22px;
  height: 22px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const BookmarkContainer = styled.div<{
  $isActive: boolean;
  $isWebView: boolean;
  $isCurrentItemPage: boolean;
  $isGalleryHeader: boolean;
  $renderCurrentIcons: boolean;
}>`
  display: inline-block;
  border: 0;
  padding: 0;
  margin: 0;
  position: absolute;
  z-index: 4;
  width: 20px;
  height: 20px;

  ${({ $renderCurrentIcons }) =>
    $renderCurrentIcons ? currentItemIconsStyles : backgroundImageStyles}
`;

export const BookmarkArea = styled.span<{ $renderCurrentIcons: boolean }>`
  float: none;
  padding: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  cursor: pointer;

  ${({ $renderCurrentIcons }) =>
    !$renderCurrentIcons &&
    css`
      opacity: 0;
    `}
`;
